import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Button, CircularProgress, TextField } from "@material-ui/core";

import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@material-ui/core/InputAdornment";

import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import clsx from "clsx";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  deleteUser,
  getUserGroups,
  getUsers,
  searchUsers,
} from "../../../service/endpoint-manager";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../Shared/Loading";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import Typography from "@material-ui/core/Typography";

import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import Skeleton from "@mui/material/Skeleton";

import { UserTable } from "@thequantumhub/iam-package";
import SearchTable from "./SearchTable";

import BulkUpdate from "./BulkUpdate";

import { USERS_PER_PAGE } from "../../../types/micellinous-constants";
import CreateUser from "../Register/CreateUser";
import { MatxTable, MatxTableCell, MatxTableHead } from "../Shared";

import styles from "../../../styles.module.css"; // Importing CSS module for styles.
import "../../../styles.module.css";

const headCells = [
  {
    label: "Sr.",
    align: "left",
    id: "sr",
  },
  {
    label: "User Name",
    align: "left",
    id: "userName",
  },
  {
    label: "User Group",
    align: "left",
    id: "userGroup",
  },
  {
    label: "Action",
    align: "left",
    id: "userAction",
  },
];

const ViewUsers = () => {
  const useStyles = makeStyles((theme) => ({
    // Define your styles here...
  }));

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [userGroups, setUserGroups] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [userGroupLoading, setUserGroupLoading] = useState(false);

  const [searchLoading, setSearchLoading] = useState(false);
  const [lastEvaluatedUserId, setLastEvaluatedUserId] = useState(null);
  const [userGroupId, setUserGroupId] = useState();

  const [AssociatedUsersForBulkUpdate, setAssociatedUsersForBulkUpdate] =
    useState(null);

  const [openAddUserGroupDialog, setOpenAddUserGroupDialog] =
    React.useState(false);
  const [openDeleteUserDialog, setOpenDeleteUserDialog] = React.useState(false);

  const [users, setUsers] = useState(null);
  const usersPerPage = USERS_PER_PAGE;
  const [finalPageCount, setFinalPageCount] = useState(1);
  const [userPage, setUserPage] = React.useState(1);

  const [bulkUpdateSelected, setBulkUpdatedSelected] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchedUsers, setSearchedUsers] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);
  const [groups, setGroups] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const returnGroupName = (id) => {
    const name = groups?.find((group) => {
      if (group.groupId === id) {
        return group;
      }
    });

    if (name) {
      return name.groupName;
    } else {
      return "-";
    }

    return name;
  };

  // this useEffect gets user group info when component initially renders
  useEffect(() => {
    const getUserGroupsInfo = async () => {
      setLoading(true);
      const result = await getUserGroups();
      if (result?.status === 200) {
        var tempGroups = [];
        result?.data?.body?.Items.map((group) => {
          if (!group.template) {
            tempGroups.push(group);
          }
        });
        setUserGroups(tempGroups);
        setUserGroupId(tempGroups[0].ID);

        setLoading(false);
      }
    };

    getUserGroupsInfo();
  }, []);

  useEffect(() => {
    // if there has been a redirect for bulk update, set state var to true to open the corresponding component

    if (location?.state?.redirectedForBulkUpdate) {
      setBulkUpdatedSelected(true);

      setAssociatedUsersForBulkUpdate(location?.state?.bulkUpdateUserList);
    }
  }, []);

  // this useEffect gets users when component initially renders
  useEffect(() => {
    if ((searchQuery === null || searchQuery === "") && !searchedUsers) {
      const getUsersFunction = async () => {
        setLoading(true);
        const result = await getUsers(usersPerPage, lastEvaluatedUserId);
        if (result?.status === 200) {
          setUsers(result?.data?.body?.Items);
          if (result?.data?.body?.LastEvaluatedKey) {
            setLastEvaluatedUserId(
              result?.data?.body?.LastEvaluatedKey?.user_id
            );
            setFinalPageCount(finalPageCount + 1);
          } else {
            setLastEvaluatedUserId(null);
            setFinalPageCount(userPage);
          }
        }
        setLoading(false);
      };
      getUsersFunction();
    } else if (searchedUsers && (searchQuery === null || searchQuery === "")) {
      setSearchedUsers(null);
      setUserPage(1);
    }
  }, [searchQuery]);

  const handlePageBack = () => {
    if (userPage != 1) {
      setUserPage(userPage - 1);
    }
  };

  const handlePageForward = () => {
    const currentPage = userPage;
    if (userPage !== finalPageCount || finalPageCount === null) {
      setUserPage(currentPage + 1);

      if (lastEvaluatedUserId) {
        const getUsersFunction = async () => {
          setLoadingUsers(true);
          const result = await getUsers(usersPerPage, lastEvaluatedUserId);

          if (result?.status === 200) {
            setUsers([...users, ...result?.data?.body?.Items]);
            if (result?.data?.body?.LastEvaluatedKey) {
              setLastEvaluatedUserId(
                result?.data?.body?.LastEvaluatedKey?.user_id
              );
              setFinalPageCount(currentPage + 1 + 1);
            } else {
              setFinalPageCount(currentPage + 1);
              setLastEvaluatedUserId(null);
            }
          }
          setLoadingUsers(false);
        };
        getUsersFunction();
      }
    }
  };
  const handleUserClick = (id) => {
    console.log("HEHRHEJHE");
    navigate(`${id}`);
  };

  // method to handle opening addUserGroup dialog
  const handleOpenAddUserGroupDialog = () => {
    setOpenAddUserGroupDialog(true);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseAddUserGroupDialog = () => {
    setOpenAddUserGroupDialog(false);
  };

  // method to handle opening deleteUserGroup dialog
  const handleOpenDeleteUserDialog = (user_id) => {
    setUserToDelete(user_id);
    setOpenDeleteUserDialog(true);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseDeleteUserDialog = () => {
    setUserToDelete(null);
    setOpenDeleteUserDialog(false);
  };

  // method to handle closing addUserGroup dialog
  const handleDeleteUserDialog = () => {
    const deleteUserFunction = async () => {
      setLoadingUsers(true);
      const response = await deleteUser(userToDelete);

      if (response?.status === 200) {
        const newUsers = users.filter((user) => user.user_id !== userToDelete);

        if (newUsers?.length < usersPerPage) {
          const getUsersFunction = async () => {
            setLoadingUsers(true);
            const result = await getUsers(usersPerPage, null);

            if (result?.status === 200) {
              setUsers(result?.data?.body?.Items);
              if (result?.data?.body?.LastEvaluatedKey) {
                setLastEvaluatedUserId(
                  result?.data?.body?.LastEvaluatedKey?.user_id
                );
                setFinalPageCount(finalPageCount + 1);
              } else {
                setLastEvaluatedUserId(null);
                setFinalPageCount(userPage);
              }
            }
            setLoadingUsers(false);
          };
          getUsersFunction();
        } else {
          setUsers(newUsers);
        }

        enqueueSnackbar("User Deleted", {
          variant: "success",
        });
      } else if (response.code === "ERR_BAD_REQUEST") {
        enqueueSnackbar(response.response.data.message, {
          variant: "error",
        });
      } else if (response.code === "ERR_NETWORK") {
        enqueueSnackbar("Network error.", {
          variant: "error",
        });
      }
      setLoadingUsers(false);
    };
    deleteUserFunction();
    setUserToDelete(null);
    setOpenDeleteUserDialog(false);
  };

  const handleSearchSubmit = async (event) => {
    event.preventDefault();

    setSearchLoading(true);

    const result = await searchUsers(searchQuery);
    if (result?.status === 200) {
      setSearchedUsers(result?.data?.body?.Items);
      setUserPage(1);
    }

    setSearchLoading(false);
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Container width="sm" className={styles.containerStyles}>
      {!bulkUpdateSelected ? (
        <section className={styles.userAccessStyles}>
          <h1 className={styles.componentHeadingStyles}>
            {!searchedUsers
              ? "Users"
              : `${searchedUsers?.length} Search Results`}
          </h1>
          {true && (
            <>
              {" "}
              <section className={styles.search}>
                <form onSubmit={(e) => handleSearchSubmit(e)}>
                  <div className={styles.searchLeft}>
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search User"
                      className={styles.searchBoxStyles}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      value={searchQuery ? searchQuery : ""}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      type="submit"
                      className={clsx(
                        styles.secondaryButton,
                        styles.searchBtnStyles
                      )}
                    >
                      Search
                    </Button>
                    {searchLoading ? (
                      <CircularProgress
                        size="1.5rem"
                        style={{ marginLeft: 10 }}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </form>
                <div className={styles.searchRight}>
                  <Button
                    variant="contained"
                    className={clsx(
                      styles.secondaryButton,
                      styles.userPageButton
                    )}
                    onClick={() => {
                      // open Add UserGroup dialog
                      setOpenAddUserGroupDialog(true);
                    }}
                  >
                    Add a User
                  </Button>
                  {/* <Button
                    variant="contained"
                    className={clsx(
                      styles.secondaryButton,
                      styles.userPageButton
                    )}
                    onClick={() => {
                      setBulkUpdatedSelected(true);
                    }}
                  >
                    Bulk Update
                  </Button> */}
                </div>
              </section>
              {/* table  -renders on large screens and up*/}
              {!searchedUsers && userGroups ? (
                <>
                  <UserTable
                    styles={styles}
                    headCells={headCells}
                    loadingUsers={loadingUsers}
                    users={users}
                    userPage={userPage}
                    usersPerPage={usersPerPage}
                    handleUserClick={handleUserClick}
                    userGroupLoading={userGroupLoading}
                    userGroups={userGroups}
                    handleOpenDeleteUserDialog={handleOpenDeleteUserDialog}
                    handlePageBack={handlePageBack}
                    handlePageForward={handlePageForward}
                    finalPageCount={finalPageCount}
                  />
                </>
              ) : (
                <SearchTable
                  styles={styles}
                  headCells={headCells}
                  loadingUsers={loading}
                  searchedUsers={searchedUsers}
                  searchQuery={searchQuery}
                  handleOpenDeleteUserDialog={handleOpenDeleteUserDialog}
                  userGroupId={userGroupId}
                  setUserGroupId={setUserGroupId}
                  userGroups={userGroups}
                  setUserGroups={setUserGroups}
                  handleUserClick={handleUserClick}
                  userGroupLoading={userGroupLoading}
                  finalPageCount={finalPageCount}
                />
              )}
              <section className={classes.cta}></section>
              {/* Add User Group Dialog - opens when 'Add User Group' button is clicked */}
              <Dialog
                scroll="paper"
                open={openAddUserGroupDialog}
                onClose={handleCloseAddUserGroupDialog}
                maxWidth="lg"
                className={styles.dialogStyles}
              >
                <DialogContent
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CreateUser
                    setOpenAddUserGroupDialog={setOpenAddUserGroupDialog}
                    user
                    users={users}
                    setUsers={setUsers}
                  />
                </DialogContent>
              </Dialog>
              {/* Delete User Group Dialog - opens when 'Delete' button is clicked next to each usergroup entry in the table*/}
              <Dialog
                open={openDeleteUserDialog}
                onClose={handleCloseDeleteUserDialog}
                maxWidth="lg"
                className={classes.dialogStyles}
              >
                <DialogTitle id="add-userGroup-dialog">Delete User</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to delete this User? It will be
                    permanent
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActionStyles}>
                  <Button
                    onClick={handleCloseDeleteUserDialog}
                    color="primary"
                    className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleDeleteUserDialog()}
                    color="primary"
                    className={clsx(
                      classes.btnStyles,
                      classes.dialogDeleteBtnStyles
                    )}
                    variant="contained"
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        </section>
      ) : (
        <BulkUpdate
          setBulkUpdatedSelected={setBulkUpdatedSelected}
          AssociatedUsersForBulkUpdate={AssociatedUsersForBulkUpdate}
          userGroupId={userGroupId}
          setUserGroupId={setUserGroupId}
          userGroups={userGroups}
          setUserGroups={setUserGroups}
        />
      )}
    </Container>
  );
};

export default ViewUsers;
